// eslint-disable-next-line angular/factory-name
angular.
module("digiexam.services").
factory("student", function studentFactory($http, Exam) {
	"use strict";

	return {
		get: function get(studentId) {
			return $http.get("/student/" + studentId).then(function success(response) {
				return response.data;
			});
		},
		getByUserAndOrganization: function getByUserAndOrganization(userId, organizationId) {
			return $http.get("/student/query?userId=" + userId + "&organizationId=" + organizationId).then(function success(response) {
				return response.data;
			});
		},
		update: function update(s) {
			return $http.post("/student/update", s).then(function success(response) {
				return response.data;
			});
		},
		query: function query(queryParams) {
			var requestConfig = {
				url: "/student/query",
				method: "GET",
				params: queryParams,
			};

			return $http(requestConfig).then(function success(response) {
				return response.data;
			});
		},
		exams: function exams(studentId) {
			return $http.get("/student/" + studentId + "/exams").then(function success(response) {
				var studentExams = [];

				if (response.data) {
					for (var i = 0; i < response.data.length; i++) {
						studentExams.push(new Exam(response.data[i]));
					}
				}
				return studentExams;
			});
		},
		listDeletableStudents: function listDeletableStudents(organizationId, noUserCriteria) {
			var requestConfig = {
				url: "/student/listdeletable/" + organizationId,
				method: "GET",
				params: {
					noUser: noUserCriteria,
				},
			};

			return $http(requestConfig).then(function success(response) {
				return response.data;
			});
		},
		batchDelete: function batchDelete(studentIds, noUserCriteria) {
			var requestConfig = {
				url: "/student/batchdelete",
				method: "POST",
				data: {
					studentIds: studentIds,
					noUser: noUserCriteria,
				},
			};

			return $http(requestConfig).then(function success(response) {
				return response.data;
			});
		},
	};
});
